export const MAX_MOBILE_DISPLAY_SIZE = 767
export const MIN_TABLET_DISPLAY_SIZE = 768
export const MAX_TABLET_DISPLAY_SIZE = 991
